var _rect, _path, _g, _path2, _g2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1957,
    viewBox: "0 0 1920 1957",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6363_61012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1957
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1957,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6363_61012)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6363_61012",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -367,
    y: -807,
    width: 2668,
    height: 3095
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2301 -806.93H-367V2287.93H2301V-806.93Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6363_61012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-477.931 1199.01L-481.996 1197.84C-459.927 1097.37 -416.37 1026.52 -355.972 992.837C-310.673 967.864 -256.662 964.38 -203.813 982.964C-177.098 992.256 -149.803 1005.03 -123.088 1017.81C-48.1703 1053.24 29.6513 1089.82 103.407 1049.17C167.872 1013.16 223.624 921.984 277.635 833.129C336.872 736.142 397.852 635.09 471.027 608.956C550.591 580.499 628.412 643.802 703.911 705.362C776.505 764.599 851.423 825.579 926.922 803.51C1027.39 774.472 1105.79 607.795 1181.87 446.344C1260.86 279.086 1342.16 106.02 1449.02 88.5974C1501.29 79.886 1552.4 110.666 1602.34 140.285C1656.35 172.227 1711.52 205.33 1766.7 187.326C1801.54 175.711 1835.23 144.35 1867.17 113.57C1899.69 82.7898 1932.79 50.8482 1968.22 39.233C2033.26 17.1642 2105.28 61.8825 2171.48 165.257C2230.14 257.017 2277.18 380.718 2322.48 499.774L2318.42 501.516C2273.12 382.461 2226.08 259.34 2168 167.58C2102.96 65.9479 2032.68 21.8103 1969.96 43.2983C1935.7 54.9135 1902.59 86.2744 1870.07 116.474C1837.55 147.254 1803.28 179.776 1767.86 191.391C1710.94 209.976 1654.61 176.292 1600.02 143.769C1550.66 114.731 1500.13 84.5321 1449.6 92.6627C1345.07 110.085 1263.76 281.99 1185.36 448.086C1109.28 610.118 1030.3 777.376 927.502 807.575C849.681 830.225 774.182 768.084 700.426 708.266C626.089 647.286 548.848 584.564 471.608 612.441C400.174 637.994 339.195 737.884 280.538 834.871C226.528 923.727 170.195 1016.07 104.569 1052.65C28.4897 1094.47 -49.9125 1057.3 -125.992 1021.29C-152.126 1009.1 -179.421 995.741 -206.136 986.449C-257.824 968.445 -310.673 971.93 -354.81 996.321C-412.886 1030.01 -455.862 1099.7 -477.931 1199.01Z",
    fill: "#B05800"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6363_61012",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -367,
    y: -807,
    width: 2668,
    height: 3095
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2301 -806.93H-367V2287.93H2301V-806.93Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6363_61012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-491.857 1035.83L-495.922 1034.66C-448.3 893.539 -316.468 870.309 -217.739 892.959C-191.024 899.347 -163.729 907.478 -137.595 915.608C-62.6768 938.839 15.1447 963.23 89.4817 935.935C153.946 912.705 209.698 852.306 263.709 794.23C322.946 730.347 384.506 664.14 457.101 647.298C536.084 628.714 613.906 670.529 689.404 710.601C761.999 749.512 836.917 789.584 912.996 775.065C1013.47 755.9 1092.45 646.718 1167.95 541.02C1246.93 431.257 1328.24 317.428 1435.1 305.813C1486.78 300.005 1538.47 320.332 1588.42 339.497C1642.43 360.404 1698.18 382.473 1752.77 370.277C1787.62 362.727 1821.3 341.82 1853.82 321.493C1886.35 301.167 1919.45 280.26 1954.87 272.71C2019.34 258.191 2091.35 287.81 2157.56 355.758C2216.22 416.157 2263.26 497.463 2308.56 575.865L2305.07 578.188C2259.77 499.786 2212.73 419.061 2154.66 359.243C2089.61 292.456 2019.34 263.418 1956.04 277.356C1921.19 284.906 1888.09 305.813 1856.15 325.559C1823.62 345.885 1789.36 366.793 1753.93 374.342C1697.6 386.538 1641.27 364.47 1586.67 342.981C1537.31 323.816 1486.2 304.071 1435.68 309.298C1330.56 320.913 1249.84 433.58 1171.43 542.762C1095.35 649.041 1016.37 759.385 913.577 778.55C836.336 793.069 760.257 752.416 687.081 713.505C612.744 673.433 535.503 632.199 457.682 650.783C385.668 667.625 325.269 733.25 266.032 796.553C211.441 855.21 155.688 915.608 90.0624 939.419C14.564 966.715 -63.8383 942.323 -139.918 919.093C-166.052 910.962 -193.347 902.251 -220.062 896.443C-315.306 874.955 -445.396 897.605 -491.857 1035.83Z",
    fill: "#009999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6363_61012",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -367,
    y: -807,
    width: 2668,
    height: 3095
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2301 -806.93H-367V2287.93H2301V-806.93Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6363_61012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1923.44 220.477H1894.4V508.532H1923.44V220.477Z",
    fill: "url(#paint0_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.75 366.789H1824.71V549.728H1853.75V366.789Z",
    fill: "url(#paint1_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.05 277.352H1755.02V597.349H1784.05V277.352Z",
    fill: "url(#paint2_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.79 375.492H1684.75V470.736H1713.79V375.492Z",
    fill: "url(#paint3_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.1 311.031H1615.06V442.282H1644.1V311.031Z",
    fill: "url(#paint4_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.4 225.688H1545.36V488.19H1574.4V225.688Z",
    fill: "url(#paint5_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.13 188.516H1475.09V432.434H1504.13V188.516Z",
    fill: "url(#paint6_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.45 205.359H1405.41V487.027H1434.45V205.359Z",
    fill: "url(#paint7_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.17 118.836H1335.14V469.033H1364.17V118.836Z",
    fill: "url(#paint8_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.48 183.844H1265.45V474.222H1294.48V183.844Z",
    fill: "url(#paint9_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.8 333.109H1195.76V492.818H1224.8V333.109Z",
    fill: "url(#paint10_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.216 506.773H706.178V883.685H735.216V506.773Z",
    fill: "url(#paint11_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.52 514.281H636.482V925.458H665.52V514.281Z",
    fill: "url(#paint12_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.245 506.172H566.207V686.207H595.245V506.172Z",
    fill: "url(#paint13_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.561 456.797H496.523V841.258H525.561V456.797Z",
    fill: "url(#paint14_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.288 651.953H426.25V823.277H455.288V651.953Z",
    fill: "url(#paint15_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.598 625.227H356.561V952.774H385.598V625.227Z",
    fill: "url(#paint16_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.911 600.859H286.873V1088.11H315.911V600.859Z",
    fill: "url(#paint17_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.626 775.094H216.588V1089.86H245.626V775.094Z",
    fill: "url(#paint18_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.94 904.57H146.902V1021.3H175.94V904.57Z",
    fill: "url(#paint19_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.243 594.469H77.2051V1294.86H106.243V594.469Z",
    fill: "url(#paint20_linear_6363_61012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9715 777.406H6.93359V1016.1H35.9715V777.406Z",
    fill: "url(#paint21_linear_6363_61012)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6363_61012",
    x1: 1909.21,
    y1: 508.882,
    x2: 1909.21,
    y2: 220.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6363_61012",
    x1: 1839.3,
    y1: 549.442,
    x2: 1839.3,
    y2: 366.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6363_61012",
    x1: 1769.38,
    y1: 597.213,
    x2: 1769.38,
    y2: 277.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6363_61012",
    x1: 1699.48,
    y1: 470.451,
    x2: 1699.48,
    y2: 375.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6363_61012",
    x1: 1629.57,
    y1: 442.675,
    x2: 1629.57,
    y2: 311.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6363_61012",
    x1: 1559.65,
    y1: 488.483,
    x2: 1559.65,
    y2: 225.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6363_61012",
    x1: 1489.74,
    y1: 432.227,
    x2: 1489.74,
    y2: 188.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6363_61012",
    x1: 1419.83,
    y1: 487.038,
    x2: 1419.83,
    y2: 205.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6363_61012",
    x1: 1349.92,
    y1: 469.392,
    x2: 1349.92,
    y2: 119.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6363_61012",
    x1: 1280,
    y1: 474.13,
    x2: 1280,
    y2: 183.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6363_61012",
    x1: 1210.1,
    y1: 493.022,
    x2: 1210.1,
    y2: 333.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6363_61012",
    x1: 720.71,
    y1: 883.686,
    x2: 720.71,
    y2: 506.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6363_61012",
    x1: 650.793,
    y1: 925.588,
    x2: 650.793,
    y2: 514.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6363_61012",
    x1: 580.878,
    y1: 686.256,
    x2: 580.878,
    y2: 506.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6363_61012",
    x1: 510.973,
    y1: 841.307,
    x2: 510.973,
    y2: 456.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6363_61012",
    x1: 441.059,
    y1: 823.559,
    x2: 441.059,
    y2: 652.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6363_61012",
    x1: 371.149,
    y1: 952.956,
    x2: 371.149,
    y2: 625.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6363_61012",
    x1: 301.24,
    y1: 1088.33,
    x2: 301.24,
    y2: 600.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6363_61012",
    x1: 231.314,
    y1: 1090.11,
    x2: 231.314,
    y2: 775.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6363_61012",
    x1: 161.407,
    y1: 1021.07,
    x2: 161.407,
    y2: 904.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6363_61012",
    x1: 91.4888,
    y1: 1295.33,
    x2: 91.4888,
    y2: 594.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6363_61012",
    x1: 21.5774,
    y1: 1015.86,
    x2: 21.5774,
    y2: 777.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921069,
    stopColor: "#000808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#001E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#004242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#00B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.2efaf9353426fc8b448281a8c7a72820.svg";
export { ForwardRef as ReactComponent };